import { useQuery } from "@tanstack/react-query";
import { fetchAllSubscriptions } from "../api/fetchAllSubscriptions";

export const useAllSubscriptions = (filters = {}, enabled = true) => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["allSubscriptions", filters],
    queryFn: () => fetchAllSubscriptions(filters),
    enabled,
  });

  return {
    data: data?.result || null,
    subscriptions: data?.result?.subscriptions || [],
    pagination: data?.result?.pagination || null,
    error,
    isLoading,
    refetch,
  };
};

